import { Component, Input, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UntypedFormControl } from '@angular/forms';
import { map, Observable } from 'rxjs';
import { CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { EmployeesListModel } from '../../employees/employees-list.model';
import { EmployeesListService } from '../../employees/employees-list.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { BankAccountService } from '../bancos/bankaccount.service';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-creditos-con-empleados-form',
    templateUrl: './creditos-con-empleados-form.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosFormComponent implements OnInit {

  @Input() creditosConEmpleados: CreditosConEmpleadosModel;
  @Output() onSave = new EventEmitter<any>();

  public loading = false;
  public ready = false;

  public employeesList: EmployeesListModel[] = [];
  public employeesControl = new UntypedFormControl();
  public employeesfiltered: Observable<EmployeesListModel[]>;

  public bankAccounts: BankAccountModel[] = [];

  constructor(
    public snackBar: MatSnackBar,
    private employeesListService: EmployeesListService,
    public bankAccountService: BankAccountService,
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
      });

    this.employeesListService.getList()
      .then(employees => {
        this.employeesList = employees;
        this.ready = true;
      })
      .catch(err => {
        this.ready = true;
      });

    this.employeesControl = new UntypedFormControl();
    this.employeesfiltered = this.employeesControl.valueChanges
      .pipe(
        map(employee => employee && typeof employee === 'object' ? employee.name : employee),
        map(name => this._filter(name))
      );

  }

  private _filter(val: string): EmployeesListModel[] {
    for (const employee of this.employeesList) {
      if (employee.name == val) {
        this.creditosConEmpleados.employeesName = employee.name;
      }
    }

    return val ? this.employeesList.filter(s => s.name.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.employeesList;
  }

  public save(): void {
    this.loading = true;
    let noError = true;
    const missing: string[] = [];

    if (this.creditosConEmpleados.employeesId == null) {
      noError = false;
      this.loading = false;
      missing.push('Empleado');
    }

    if (this.creditosConEmpleados.importeInicial == null) {
      noError = false;
      this.loading = false;
      missing.push('Importe inicial');
    }

    if (this.creditosConEmpleados.importePendiente == null) {
      noError = false;
      this.loading = false;
      missing.push('Importe pendiente');
    }

    if (this.creditosConEmpleados.fechaConstitucion == null) {
      noError = false;
      this.loading = false;
      missing.push('Fecha de constitución');
    }

    if (this.creditosConEmpleados.plazo == null) {
      noError = false;
      this.loading = false;
      missing.push('Plazo');
    }

    if (this.creditosConEmpleados.fechaFinalizacion == null) {
      noError = false;
      this.loading = false;
      missing.push('Fecha de finalización');
    }

    if (this.creditosConEmpleados.tipoInteres == null) {
      noError = false;
      this.loading = false;
      missing.push('Tipo de Intereses');
    }

    if (this.creditosConEmpleados.carencia == null) {
      noError = false;
      this.loading = false;
      missing.push('Carencia');
    }

    if (this.creditosConEmpleados.tipoLiquidaciones == null || this.creditosConEmpleados.tipoLiquidaciones === 0) {
      noError = false;
      this.loading = false;
      missing.push('Tipos de liquidaciones');
    }

    if (this.creditosConEmpleados.bankAccountsUid == null || this.creditosConEmpleados.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.loading = false;
      missing.push('Cuenta de abono');
    }

    if (missing.length) {
      this.displayInfo('Revisa los campos obligatorios: ' + missing.join(', '));
    }

    this.setDefaultsValues();

    if (noError) {
      this.onSave.emit(this.creditosConEmpleados);
      this.loading = false;
    }
  }

  public setDefaultsValues(): void {
    // Valores por defecto en los campos que no sean requeridos
  }

  public setEmployeeIdentifier(selectedEmplooyeId: number) {
    this.creditosConEmpleados.employeesId = selectedEmplooyeId;
  }

  public setTipoDeLiquidacionesOptions(value: number) {
    this.creditosConEmpleados.tipoLiquidaciones = value;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
